






















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class PaginationComponent extends Vue {
  @Prop({ default: 1 }) private readonly totalRows!: any;
  @Prop({ default: 10 }) private readonly perPage!: any;
  @Prop({ default: 1 }) private readonly currentPage!: any;
  private totalPages: any = 1;
  private perPageSelected: any = this.perPage;
  @Prop({ default: false }) private readonly enablePerPage!: boolean;

  private emitPerPage() {
    this.$emit("per-page", this.perPageSelected);
  }

  @Watch("perPage")
  public onValueChange(val: any, oldVal: any) {
    this.$emit("change", this.perPageSelected);
  }

  get pages() {
    this.totalPages = Math.ceil(this.totalRows / this.perPageSelected);

    if (this.currentPage > 5) {
      return this.fillRange(this.currentPage - 4, this.currentPage);
    }

    return this.fillRange(1, this.totalPages > 5 ? 5 : this.totalPages);
  }

  private fillRange(start: any, end: any) {
    const startValue = start < 1 ? 1 : start;
    return Array(end - startValue + 1)
      .fill(0)
      .map((item: any, index: any) => start + index);
  }

  private getPage(index: any) {
    if (this.currentPage != index) {
      this.$emit("change-page", index);
    }
  }

  private nextPage() {
    if (this.currentPage < this.totalPages && this.pages.length != 1) {
      this.$emit("change-page", this.currentPage + 1);
    }
  }

  private prevPage() {
    if (this.currentPage > 1 && this.pages.length != 1) {
      this.$emit("change-page", this.currentPage - 1);
    }
  }
}
